import React from 'react';

export default function SubscriptionStatisticsUsages({ subscriptionStatistics, setIsOpenUsageOverviewModal }) {
	return (
		<div style={{ overflowX: "auto" }}>
			<div
				className="d-flex justify-content-between align-items-center rounded-3 px-2 py-4 my-4"
				style={{ backgroundColor: 'rgba(244, 245, 249, 1)' }}
			>
				<div className="px-3">
					<div className="d-flex gap-4 align-items-center">
						<div className="fs-5 fw-semibold">{subscriptionStatistics.title}</div>
					</div>
					<div className="fs-5 fw-light">{`${subscriptionStatistics.description}`}</div>
				</div>
				{subscriptionStatistics?.data?.slice(0, 2).map((data) => {
					const total = data.total || 0;
					const completed = data.used || 0;
					const progress = total > 0 ? (completed / total) * 100 : 0;
					return (
						<div className="d-flex gap-4 align-items-center">
							<div
								className="progress"
								style={{
									height: "6px",
									borderRadius: "10px",
								}}
							>
								<div
									className={`progress-bar bg-primary`}
									style={{
										width: `${progress}%`,
									}}
								/>
							</div>
							<div>
								<div className="fs-5 fw-light text-dark">{data.feature}</div>
								<div className="fs-5 fw-light text-dark">{`${data.used} / ${data.total} ${data.feature.toLowerCase()}`}</div>
							</div>
						</div>
					);
				})}
				<div className=" px-4 fs-4 fw-bold text-primary cursor-pointer" onClick={() => setIsOpenUsageOverviewModal(true)}>View Usages</div>
			</div>
		</div>
	);
}
